import React from "react"

import { haveAuth, isInPosDevice } from "utils"
import { OrdersGroupPrintButton, OrdersSetAsViewedButton } from "components"
import PoCompleteOrdersButton from "./PoCompleteOrdersButton"
import PoGroupLabelPrintButton from "./PoGroupLabelPrintButton"
import PoMakeReportButton from "./PoMakeReportButton"
import PoGroupInvoicePrintButton from "./PoGroupInvoicePrintButton"
import classes from "./PoFooter.module.scss"

const PoFooter = (props) => {
  const {
    setOrders,
    selectedOrders,
    setSelectedOrders
  } = props

  const showGroupPrintButton =
    !isInPosDevice()

  const showLabelPrintButton =
    !isInPosDevice()

  const showInvoicePrintButton =
    !isInPosDevice()

  return (
    <div className={classes["footer"]}>
      <OrdersSetAsViewedButton
        orderStatus="paid"
        setOrders={setOrders}
      />

      {
        showGroupPrintButton &&
        <OrdersGroupPrintButton
          selectedOrders={selectedOrders}
        />
      }

      {
        showLabelPrintButton &&
        <PoGroupLabelPrintButton
          selectedOrders={selectedOrders}
        />
      }

      {
        showInvoicePrintButton &&
        <PoGroupInvoicePrintButton
          selectedOrders={selectedOrders}
        />
      }

      {
        haveAuth(["completeOrder"]) &&
        <PoCompleteOrdersButton
          setOrders={setOrders}
          selectedOrders={selectedOrders}
          setSelectedOrders={setSelectedOrders}
        />
      }

      <PoMakeReportButton
        selectedOrders={selectedOrders}
        setSelectedOrders={setSelectedOrders}
      />
    </div>
  )
}

export default PoFooter